export default "__VITE_ASSET__5vgLr8tu__"